export default {
  title: 'Tilføj kreditkort',
  buttons: {
    save: 'Gem',
  },
  feedback: {
    success: 'Kortet blev tilføjet',
  },
};
